var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgObjetivoPrimaryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 98,
    viewBox: "0 0 97 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1982 32.963C30.1982 32.1291 30.8742 31.4531 31.7081 31.4531H64.926C65.7599 31.4531 66.436 32.1291 66.436 32.963V88.6172C66.436 89.8987 64.94 90.5976 63.9571 89.7752L48.929 77.2006C48.3592 76.7239 47.5273 76.7324 46.9675 77.2208L32.7007 89.6663C31.724 90.5184 30.1982 89.8247 30.1982 88.5285V32.963Z",
    fill: "#37994F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_532_17526)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48.3172,
    cy: 37.4925,
    r: 30.1981,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.3172,
    cy: 37.4925,
    r: 30.5756,
    stroke: "url(#paint0_linear_532_17526)",
    strokeOpacity: 0.5,
    strokeWidth: 0.754952
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_532_17526)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_532_17526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 46.75C53.3848 46.75 57.75 42.3848 57.75 37C57.75 31.6152 53.3848 27.25 48 27.25C42.6152 27.25 38.25 31.6152 38.25 37C38.25 42.3848 42.6152 46.75 48 46.75Z",
    stroke: "white",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.75 34.8335H44.76",
    stroke: "white",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.25 34.8335H51.26",
    stroke: "white",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.292 40.25C45.645 40.6103 46.0664 40.8966 46.5315 41.092C46.9965 41.2874 47.4959 41.3881 48.0003 41.3881C48.5048 41.3881 49.0041 41.2874 49.4692 41.092C49.9342 40.8966 50.3556 40.6103 50.7087 40.25",
    stroke: "white",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_532_17526",
    x: 2.26521,
    y: -8.5595,
    width: 92.1043,
    height: 92.1043,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.54952
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_532_17526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_532_17526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_532_17526",
    x: 33.8955,
    y: 26.1665,
    width: 28.2089,
    height: 28.2099,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.27146
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.63573
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_532_17526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_532_17526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_532_17526",
    x1: 18.1191,
    y1: 23.7661,
    x2: 71.5979,
    y2: 108.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_532_17526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 35,
    fill: "white",
    transform: "translate(35 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjetivoPrimaryIcon);
export default __webpack_public_path__ + "static/media/objetivoPrimaryIcon.aafdc143652abc01a210ee4fb9191c66.svg";
export { ForwardRef as ReactComponent };